const signInEN = {
	title: "Sign In",
	email: "Email",
	password: "Password",
	rememberMe: "Remember me",
	button: "Sign In",
	loading: "Signing in...",
	forgotPassword: "Forgot password?",
	noAccount: "Don’t have an account?",
	createCustomer: "Create a customer account",
	registerBusiness: "Register your business",
};
export default signInEN;